<template>
  <div class="login-content">
    <div class="">
      <h5 class="card-title">B2B</h5>
      <form class="" @submit.prevent="onResetPassword">
        <div class="form-group">
          <label for="username">
            {{ $t("common.username") }}
          </label>
          <input v-model="username" class="form-control" />
        </div>
        <div class="form-group">
          <label for="phone">
            {{ $t("auth.phone") }}
          </label>
          <input v-model="phone" type="phone" class="form-control" />
        </div>
        <div v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
        <button
          :disabled="!canLogin"
          type="submit"
          class="btn btn-theme-add bg-secondary text-white"
        >
          {{ $t("auth.login") }}
        </button>
      </form>
    </div>
    <br />
  </div>
</template>

<style scoped>
.login-content {
  color: #cad2dd;
}
.login-content > h5 {
  text-align: center;
  margin: auto;
}
.form-control {
  font-size: 0.9rem;
}
.btn {
  font-size: 0.9rem;
}
:root {
  --main-bg-color: #373330;
  --main-color: #626d80;
}
.form-control:focus {
  border-color: var(--main-color);
  -moz-box-shadow: inset 0 0 4px var(--main-color);
  -webkit-box-shadow: inset 0 0 4px var(--main-color);
  box-shadow: inset 0 0 4px var(--main-color);
}
</style>

<script>
import { mapState } from "vuex";
import router from "../router";

export default {
  name: "ResetPassword",
  data() {
    return {
      username: "",
      password: "",
      error: "",
    };
  },
  computed: {
    ...mapState("auth", ["loading"]),
    canLogin() {
      return this.username.length > 3 && this.password.length > 3;
    },
  },
  methods: {
    onResetPassword() {
      this.ResetPassword({
        username: this.username,
        password: this.password,
      })
        .catch((res) => {
          if (res.status === "401") {
            this.error = this.$t("auth.errors.authorization");
          } else {
            this.error = this.$t("auth.errors.network");
          }
        })
        .then(() => {
          this.getUser()
            .then(function(results) {
              router.push({
                name: "customer",
                params: {
                  id: results.data.userCollection.allUserData[0].cardCode,
                },
              });
            })
            .catch((res) => {
              if (res.status === "401") {
                this.error = this.$t("auth.errors.authorization");
              } else {
                this.error = this.$t("auth.errors.network");
              }
            });
        });
    },
  },
};
</script>
